<form (submit)="saveAndNext()" [formGroup]="form" (keydown.enter)="saveAndNext()" class="main-form">
  <div class="card mb-4">
    <div class="card-header">
      <fa-icon [icon]="faUserTie"></fa-icon>
      {{
      [EnumEnquiryType.cargo, EnumEnquiryType.commercial].includes($safeNavigationMigration(enquiry?.type))
      ? ('GENERAL.OPERATOR' | translate)
      : ('CREWS.PLURAL' | translate)
      }}
    </div>
    <div class="card-body">
      <div class="row justify-content-center">
        <div class="col-md-6 col-lg-4">
          <div class="form-group">
            <label for="salesH24Phone" [innerText]="'GENERAL.SALES_H24' | translate"></label>
            <input
              id="salesH24Phone"
              class="form-control"
              type="text"
              formControlName="salesH24Phone"
                            [class.is-invalid]="
                                (form.touched || salesH24Phone.touched) &&
                                salesH24Phone.status === 'INVALID'
                                    ? 'danger'
                                    : ''
                            "
              />

            <div class="invalid-tooltip">
              @if (
                (form.touched || salesH24Phone.touched) &&
                salesH24Phone.errors &&
                salesH24Phone.errors['required']
                ) {
                <div
                  [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                ></div>
              }
            </div>
          </div>
          <div class="form-group">
            <label for="opsH24Phone" [innerText]="'GENERAL.OPS_H24' | translate"></label>
            <input
              id="opsH24Phone"
              class="form-control"
              type="text"
              formControlName="opsH24Phone"
                            [class.is-invalid]="
                                (form.touched || opsH24Phone.touched) &&
                                opsH24Phone.status === 'INVALID'
                                    ? 'danger'
                                    : ''
                            "
              />

            <div class="invalid-tooltip">
              @if (
                (form.touched || opsH24Phone.touched) &&
                opsH24Phone.errors &&
                opsH24Phone.errors['required']
                ) {
                <div
                  [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                ></div>
              }
            </div>
          </div>
        </div>
        @if (
          [EnumEnquiryType.business, EnumEnquiryType.helico].includes($safeNavigationMigration(enquiry?.type))
          ) {
          @if (enquiryFlight?.airlineId) {
            <div class="col-md-6 col-lg-4">
              <div class="form-group placeholder-glow">
                <label for="captainId" class="d-flex justify-content-between">
                  <span [innerText]="'FLIGHT_BRIEF.CAPTAIN' | translate"></span>
                  <button type="button" class="btn btn-icon" (click)="addCaptain()">
                    <fa-icon [icon]="faPlusCircle"></fa-icon>
                  </button>
                </label>
                @if (loadingCrewsForAirline) {
                  <div class="placeholder w-100"></div>
                }
                @if (
                  !loadingCrewsForAirline &&
                  !crewsByType[EnumCrewType.captain]?.length
                  ) {
                  <div
                    class="alert alert-warning alert-sm text-center"
                    >
                    {{ 'CREWS.NONE_CAPTAIN' | translate }}
                  </div>
                }
                @if (
                  !loadingCrewsForAirline &&
                  crewsByType[EnumCrewType.captain]?.length
                  ) {
                  <div
                    class="input-group"
                    >
                    <select
                      id="captainId"
                      class="form-select"
                      formControlName="captainId"
                                    [class.is-invalid]="
                                        (form.touched || captainId.touched) &&
                                        captainId.status === 'INVALID'
                                            ? 'danger'
                                            : ''
                                    "
                      >
                      <option
                        [ngValue]="null"
                        [innerText]="'GENERAL.PLEASE_SELECT_ONE' | translate"
                      ></option>
                      @for (item of crewsByType[EnumCrewType.captain]; track item.id) {
                        <option
                          [value]="item.id"
                          [innerText]="(hasCrewObservation(item) ? '⚠ ' : '') + item.lastname + ' ' + item.firstname"
                        ></option>
                      }
                    </select>
                    <div class="invalid-tooltip">
                      @if (
                        (form.touched || captainId.touched) &&
                        captainId.errors &&
                        captainId.errors['required']
                        ) {
                        <div
                          [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                        ></div>
                      }
                    </div>
                    @if (hasAclAccess(EnumAcl.crewsEdit) && captainId.value) {
                      <button
                        type="button"
                        class="btn btn-primary"
                        (click)="editCaptain()"
                        [appTooltip]="('GENERAL.EDIT' | translate) + ' ' + ('FLIGHT_BRIEF.CAPTAIN' | translate)"
                        >
                        <fa-icon [icon]="faEdit"></fa-icon>
                      </button>
                    }
                  </div>
                }
                @if (getPilotObservation(EnumCrewType.captain, captainId.value); as captainObservation) {
                  <div class="alert alert-warning alert-sm mt-2 mb-0" role="note">
                    <strong>{{ 'CREWS.PILOT_OBSERVATION' | translate }}</strong>
                    <div class="crew-observation" [innerText]="captainObservation"></div>
                  </div>
                }
              </div>
            </div>
          }
          @if (enquiryFlight?.airlineId) {
            <div class="col-md-6 col-lg-4">
              <div class="form-group placeholder-glow">
                <label for="coPilotId" class="d-flex justify-content-between">
                  <span [innerText]="'FLIGHT_BRIEF.FIRST_OFFICER' | translate"></span>
                  <button type="button" class="btn btn-icon" (click)="addCoPilot()">
                    <fa-icon [icon]="faPlusCircle"></fa-icon>
                  </button>
                </label>
                @if (loadingCrewsForAirline) {
                  <div class="placeholder w-100"></div>
                }
                @if (
                  !loadingCrewsForAirline &&
                  !crewsByType[EnumCrewType.coPilot]?.length
                  ) {
                  <div
                    class="alert alert-warning alert-sm text-center"
                    >
                    {{ 'CREWS.NONE_FIRST_OFFICER' | translate }}
                  </div>
                }
                @if (
                  !loadingCrewsForAirline &&
                  crewsByType[EnumCrewType.coPilot]?.length
                  ) {
                  <div
                    class="input-group"
                    >
                    <select
                      id="coPilotId"
                      class="form-select"
                      formControlName="coPilotId"
                                    [class.is-invalid]="
                                        (form.touched || coPilotId.touched) &&
                                        coPilotId.status === 'INVALID'
                                            ? 'danger'
                                            : ''
                                    "
                      >
                      <option
                        [ngValue]="null"
                        [innerText]="'GENERAL.PLEASE_SELECT_ONE' | translate"
                      ></option>
                      @for (item of crewsByType[EnumCrewType.coPilot]; track item.id) {
                        <option
                          [value]="item.id"
                          [innerText]="(hasCrewObservation(item) ? '⚠ ' : '') + item.lastname + ' ' + item.firstname"
                        ></option>
                      }
                    </select>
                    <div class="invalid-tooltip">
                      @if (
                        (form.touched || coPilotId.touched) &&
                        coPilotId.errors &&
                        coPilotId.errors['required']
                        ) {
                        <div
                          [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                        ></div>
                      }
                    </div>
                    @if (hasAclAccess(EnumAcl.crewsEdit) && coPilotId.value) {
                      <button
                        type="button"
                        class="btn btn-primary"
                        (click)="editCoPilot()"
                        [appTooltip]="('GENERAL.EDIT' | translate) + ' ' + ('FLIGHT_BRIEF.FIRST_OFFICER' | translate)"
                        >
                        <fa-icon [icon]="faEdit"></fa-icon>
                      </button>
                    }
                  </div>
                }
                @if (getPilotObservation(EnumCrewType.coPilot, coPilotId.value); as coPilotObservation) {
                  <div class="alert alert-warning alert-sm mt-2 mb-0" role="note">
                    <strong>{{ 'CREWS.PILOT_OBSERVATION' | translate }}</strong>
                    <div class="crew-observation" [innerText]="coPilotObservation"></div>
                  </div>
                }
              </div>
            </div>
          }
          @if (enquiryFlight?.airlineId) {
            <div class="col-md-6 col-lg-3">
              <div class="form-group placeholder-glow">
                <div class="d-flex gap-4">
                  <div class="form-check form-switch">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="stewardessEnabled"
                      formControlName="stewardessEnabled"
                      (change)="updatedStewardessEnabled()"
                      />
                    <label class="form-check-label" for="stewardessEnabled" [innerText]="'FLIGHT_BRIEF.FLIGHT_ATTENDANT' | translate"></label>
                  </div>
                  @if (stewardessEnabled.value) {
                    <button
                      type="button"
                      class="btn btn-icon"
                      (click)="addStewardess()"
                      >
                      <fa-icon [icon]="faPlusCircle"></fa-icon>
                    </button>
                  }
                </div>
                @if (stewardessEnabled.value) {
                  @if (loadingCrewsForAirline) {
                    <div class="placeholder w-100"></div>
                  }
                  @if (
                    !loadingCrewsForAirline &&
                    !crewsByType[EnumCrewType.stewardess]?.length
                    ) {
                    <div
                      class="alert alert-warning alert-sm text-center mb-1"
                      >
                      {{ 'CREWS.NONE_FLIGHT_ATTENDANT' | translate }}
                    </div>
                  }
                  @for (crew of crewsByType[EnumCrewType.stewardess]; track crew.id) {
                    <div
                      class="form-check"
                      >
                      <input
                        class="form-check-input"
                        type="checkbox"
                        [id]="'crew-' + crew.id"
                        [checked]="stewardessIds.value.includes(crew.id)"
                        (change)="toggleStewardessId(crew.id)"
                        />
                      <label
                        class="form-check-label"
                        [attr.for]="'crew-' + crew.id"
                        [innerText]="crew.lastname + ' ' + crew.firstname"
                        >
                      </label>
                      <button
                        type="button"
                        class="btn btn-icon"
                        (click)="editStewardess(crew.id)"
                        >
                        <fa-icon [icon]="faEdit"></fa-icon>
                      </button>
                    </div>
                  }
                }
              </div>
            </div>
          }
        }
        @if (enquiryFlight?.airlineId) {
          <div class="col-md-6 col-lg-3">
            <div class="form-group placeholder-glow mb-4">
              <div class="d-flex gap-4">
                <div class="form-check form-switch">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="departSupervisorEnabled"
                    formControlName="departSupervisorEnabled"
                    (change)="updatedSupervisorEnabled('depart')"
                    />
                  <label
                    class="form-check-label"
                    for="departSupervisorEnabled"
                    [innerText]="'AIRLINE_SUPERVISORS.DEPARTURE' | translate"
                  ></label>
                </div>
                @if (departSupervisorEnabled.value) {
                  <button
                    type="button"
                    class="btn btn-icon"
                    (click)="addSupervisor('depart')"
                    >
                    <fa-icon [icon]="faPlusCircle"></fa-icon>
                  </button>
                }
              </div>
              @if (departSupervisorEnabled.value) {
                @if (loadingDepartSupervisorsForAirport) {
                  <div class="placeholder w-100"></div>
                }
                @if (!loadingDepartSupervisorsForAirport && !departSupervisors.length) {
                  <div
                    class="alert alert-warning alert-sm text-center"
                    >
                    {{ 'AIRPORT_SUPERVISORS.NONE' | translate }}
                  </div>
                }
                @for (supervisor of departSupervisors; track supervisor.id) {
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      [id]="'depart-supervisor-' + supervisor.id"
                      [checked]="departSupervisorIds.value.includes(supervisor.id)"
                      (change)="toggleSupervisorId('depart', supervisor.id)"
                      />
                    <label
                      class="form-check-label"
                      [attr.for]="'depart-supervisor-' + supervisor.id"
                      [innerText]="supervisor.lastname + ' ' + supervisor.firstname"
                      >
                    </label>
                    <button
                      type="button"
                      class="btn btn-icon"
                      (click)="supervisorLegForModal = 'depart'; editSupervisor(supervisor.id)"
                      >
                      <fa-icon [icon]="faEdit"></fa-icon>
                    </button>
                  </div>
                }
              }
            </div>
            <div class="form-group placeholder-glow">
              <div class="d-flex gap-4">
                <div class="form-check form-switch">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="arrivalSupervisorEnabled"
                    formControlName="arrivalSupervisorEnabled"
                    (change)="updatedSupervisorEnabled('arrival')"
                    />
                  <label
                    class="form-check-label"
                    for="arrivalSupervisorEnabled"
                    [innerText]="'AIRLINE_SUPERVISORS.ARRIVAL' | translate"
                  ></label>
                </div>
                @if (arrivalSupervisorEnabled.value) {
                  <button
                    type="button"
                    class="btn btn-icon"
                    (click)="addSupervisor('arrival')"
                    >
                    <fa-icon [icon]="faPlusCircle"></fa-icon>
                  </button>
                }
              </div>
              @if (arrivalSupervisorEnabled.value) {
                @if (loadingArrivalSupervisorsForAirport) {
                  <div class="placeholder w-100"></div>
                }
                @if (!loadingArrivalSupervisorsForAirport && !arrivalSupervisors.length) {
                  <div
                    class="alert alert-warning alert-sm text-center"
                    >
                    {{ 'AIRPORT_SUPERVISORS.NONE' | translate }}
                  </div>
                }
                @for (supervisor of arrivalSupervisors; track supervisor.id) {
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      [id]="'arrival-supervisor-' + supervisor.id"
                      [checked]="arrivalSupervisorIds.value.includes(supervisor.id)"
                      (change)="toggleSupervisorId('arrival', supervisor.id)"
                      />
                    <label
                      class="form-check-label"
                      [attr.for]="'arrival-supervisor-' + supervisor.id"
                      [innerText]="supervisor.lastname + ' ' + supervisor.firstname"
                      >
                    </label>
                    <button
                      type="button"
                      class="btn btn-icon"
                      (click)="supervisorLegForModal = 'arrival'; editSupervisor(supervisor.id)"
                      >
                      <fa-icon [icon]="faEdit"></fa-icon>
                    </button>
                  </div>
                }
              }
            </div>
          </div>
        }
      </div>
    </div>
  </div>

  <div class="row mb-4">
    <div class="col">
      <button
        type="button"
        class="btn btn-secondary"
        [disabled]="form.disabled"
        (click)="prev()"
        >
        <fa-icon [icon]="faArrowLeft"></fa-icon>
        {{ 'GENERAL.PREVIOUS' | translate }}
      </button>
    </div>
    <div class="col text-end">
      <button
        type="button"
        class="btn btn-primary"
        [disabled]="form.disabled || !form.valid"
        (click)="saveAndNext()"
        >
        {{ 'GENERAL.NEXT' | translate }}
        <fa-icon [icon]="faArrowRight"></fa-icon>
      </button>
    </div>
  </div>
</form>

<div class="modal" tabindex="-1" role="dialog" #modalCaptain>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5
          class="modal-title"
          [innerText]="editingCaptain ? ('CREWS.EDIT_CAPTAIN' | translate) : ('CREWS.ADD_CAPTAIN' | translate)"
        ></h5>
        <button
          type="button"
          class="btn-close"
          [attr.aria-label]="'GENERAL.CLOSE' | translate"
          (click)="dismissCaptainModal()"
        ></button>
      </div>
      @if (enquiryFlight?.airlineId) {
        <app-crew-edit
          [inModal]="true"
          [crewId]="editingCaptain?.id || null"
          [defaultAirlineId]="$safeNavigationMigration(enquiryFlight?.airlineId)"
          [defaultCrewType]="EnumCrewType.captain"
          (dismissModal)="dismissCaptainModal($event)"
        ></app-crew-edit>
      }
    </div>
  </div>
</div>

<div class="modal" tabindex="-1" role="dialog" #modalCoPilot>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5
          class="modal-title"
          [innerText]="editingCoPilot ? ('CREWS.EDIT_FIRST_OFFICER' | translate) : ('CREWS.ADD_FIRST_OFFICER' | translate)"
        ></h5>
        <button
          type="button"
          class="btn-close"
          [attr.aria-label]="'GENERAL.CLOSE' | translate"
          (click)="dismissCoPilotModal()"
        ></button>
      </div>
      @if (enquiryFlight?.airlineId) {
        <app-crew-edit
          [inModal]="true"
          [crewId]="editingCoPilot?.id || null"
          [defaultAirlineId]="$safeNavigationMigration(enquiryFlight?.airlineId)"
          [defaultCrewType]="EnumCrewType.coPilot"
          (dismissModal)="dismissCoPilotModal($event)"
        ></app-crew-edit>
      }
    </div>
  </div>
</div>

<div class="modal" tabindex="-1" role="dialog" #modalStewardess>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5
          class="modal-title"
          [innerText]="editingStewardess ? ('CREWS.EDIT_FLIGHT_ATTENDANT' | translate) : ('CREWS.ADD_FLIGHT_ATTENDANT' | translate)"
        ></h5>
        <button
          type="button"
          class="btn-close"
          [attr.aria-label]="'GENERAL.CLOSE' | translate"
          (click)="dismissStewardessModal()"
        ></button>
      </div>
      @if (enquiryFlight?.airlineId) {
        <app-crew-edit
          [inModal]="true"
          [crewId]="editingStewardess?.id || null"
          [defaultAirlineId]="$safeNavigationMigration(enquiryFlight?.airlineId)"
          [defaultCrewType]="EnumCrewType.stewardess"
          (dismissModal)="dismissStewardessModal($event)"
        ></app-crew-edit>
      }
    </div>
  </div>
</div>

<div class="modal" tabindex="-1" role="dialog" #modalSupervisor>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5
          class="modal-title"
          [innerText]="editingSupervisor ? ('AIRPORT_SUPERVISORS.EDIT' | translate) : ('AIRPORT_SUPERVISORS.ADD' | translate)"
        ></h5>
        <button
          type="button"
          class="btn-close"
          [attr.aria-label]="'GENERAL.CLOSE' | translate"
          (click)="dismissSupervisorModal()"
        ></button>
      </div>
      @if (enquiryFlight?.airportDepartId || enquiryFlight?.airportArrivalId) {
        <app-airport-supervisor-edit
          [inModal]="true"
          [airportSupervisorId]="editingSupervisor?.id || null"
                [defaultAirportId]="
                    supervisorLegForModal === 'depart'
                        ? $safeNavigationMigration(enquiryFlight?.airportDepartId)
                        : $safeNavigationMigration(enquiryFlight?.airportArrivalId)
                "
          (dismissModal)="dismissSupervisorModal($event)"
        ></app-airport-supervisor-edit>
      }
    </div>
  </div>
</div>
